/*eslint no-use-before-define:0 *///TODO REMOVE THIS
/*global screen localStorage*/
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var esUtils = require('ES/utils/esUtils');
var radio = require("ES/lib/react-pubsub-via-radio.js/radio");
var RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup: function () {
		return {
			Quickbooks_readAuth: {
				key: function () {
					return 1;
				}
			},
			Quickbooks_disconnectAuth: {
				key: function () {
					return 1;
				}
			}
		};
	},
	getInitialState: function () {
		return {sid: -1};
	},
	componentWillReceiveProps: function (props) {
		this.__loadForSid(props.selected_sid);
	},
	componentDidMount: function () {
		this.__loadForSid(this.props.selected_sid);
	},
	__loadForSid: function (sid) {
		if (sid != this.state.sid) {
			this.setState({sid: sid}, function () {
				radio('Quickbooks_readAuth').broadcast({sid: sid});
			});
		}
	},
	_openConnectPopup: function () {
		var connect_url = '/balboa3/quickbooks/connectauth/?sid=' + this.state.sid + '&' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
		var wind = {height: 640, width: 800};
		var parameters = 'location=1';
		parameters += ',width=' + wind.width + ',height=' + wind.height;
		parameters += ',left=' + (screen.width - wind.width) / 2 + ',top=' + (screen.height - wind.height) / 2;
		window.open(connect_url, 'Intuit QuickBooks Authorize Popup', parameters);
	},
	_disconnectAccount: esUtils.wrapPreventDefault(function (e) {
		localStorage.removeItem('connection_type');
		radio('Quickbooks_disconnectAuth').broadcast({sid: this.state.sid});
	}),
	render: function () {

		var ajax = this.state.Quickbooks_readAuth;
		var ajax2 = this.state.Quickbooks_disconnectAuth;
		var isConnected = ajax.data && ajax.data.data.is_connected;
		if (ajax2.data && ajax2.data.data && ajax2.data.data.is_connected === false) {
			isConnected = false;
		}
		var Displaylists = this.props.Displaylists;
		var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
			return spkr.sid == this.state.sid;
		}, this);
		var originEid = localStorage.getItem('origin_eid') ? localStorage.getItem('origin_eid') : null;
		if (isConnected) {
			localStorage.removeItem('origin_eid');
		}
		return dd.div(null,
			LoadingWrap({is_loading: ajax.waiting || ajax2.waiting, glass: true},
				dd.h3(null, 'QuickBooks connector for ',
					dd.span({className: 'nametag'},
						AuthedUserSession.MY_USERNAME),
					' + ',
					dd.span({className: 'nametag'},
						speaker ? speaker.name_full : '')
				),
				dd.p({className: 'text-muted'},
					'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ',
					'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'
				),
				ErrorAlert({message: ajax.error}),
				ErrorAlert({message: ajax2.error}),
				isConnected ? dd.div(null,
					dd.div({className: 'alert alert-success'},
						'You are connected to QuickBooks!'
					),
					dd.a({href: '#', onClick: this._disconnectAccount}, 'Click here to disconnect your QuickBooks account.'),
					(originEid ? dd.div({style: {marginTop: '20px'}},
						dd.a({href: '#/events/' + originEid + '/services', className: 'btn btn-default'},
							dd.i({className: 'fa fa-arrow-left'}),
							' Back to last viewed event'
						)
					) : '')
				) : dd.div(null,
					( originEid ? dd.div({className: 'alert alert-info'},
						dd.strong(null, 'Heads Up!'), ' In order to use the QuickBooks Online invoice feature, you\'ll first need to connect your QuickBooks account.'
					) : ''),
					dd.p(null,
						'The link below will open a popup to Intuit\'s site, where you can sign in.'
					),
					dd.p(null,
						'Intuit will ask permission to securely share your data with eSpeakers, and you should ', dd.b(null, 'choose AUTHORIZE.')
					),
					dd.a({onClick: this._openConnectPopup, className: 'btn btn-primary'},
						'Connect to your QuickBooks account'
					),
					dd.br(),
					dd.br()
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/Quickbooks.js